import {Component} from '@angular/core';
import {RouterLink} from "@angular/router";
import {FooterModule} from "../../components/footer/footer.module";

/** Returns and complaints: the right to withdraw from an online purchase and how to use it. */
@Component({
    selector: 'app-returns-policy',
    standalone: true,
    imports: [RouterLink, FooterModule],
    template: `
        <article class="px-5 pt-[8.5rem] lg:pt-52 pb-16 max-w-3xl mx-auto text-left text-gray-800 leading-relaxed">
            <h1 class="text-2xl lg:text-4xl font-bold text-gray-900">Враќање и рекламации</h1>
            <p class="pt-3">Сакаме да бидете задоволни од секоја нарачка. Ако нешто не е во ред, јавете ни се и ќе го решиме.</p>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Право на враќање во рок од 15 дена</h2>
            <p class="pt-2">
                Производ купен онлајн можете да го вратите без да наведете причина, во рок од
                <strong>15 дена</strong> од денот кога ја примивте пратката.
            </p>
            <ul class="list-disc pl-5 pt-2 space-y-1">
                <li>Производот треба да е <strong>неотворен и неупотребен</strong>, во оригиналното пакување и со неоштетена заштитна лента.</li>
                <li>Од хигиенски и здравствени причини, не може да се врати храна, пијалок, додаток во исхраната или козметика што е отворена откако ја примивте.</li>
                <li>Трошокот за враќање на пратката го плаќа купувачот, освен ако производот е оштетен или погрешно испорачан.</li>
            </ul>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Како да вратите производ</h2>
            <ol class="list-decimal pl-5 pt-2 space-y-1">
                <li>Јавете ни се или пишете на Viber на <a class="text-primaryDark underline whitespace-nowrap" href="tel:+38973857133">073/857-133</a>,
                    или пратете порака преку <a class="text-primaryDark underline" routerLink="/contact-us">контакт формата</a>.
                    Наведете го името од нарачката и кој производ го враќате.</li>
                <li>Ќе ви кажеме на која адреса и на кој начин да го пратите производот.</li>
                <li>Откако ќе го примиме и прегледаме производот, парите ви ги враќаме на вашата трансакциска сметка најдоцна за 15 дена.</li>
            </ol>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Оштетен или погрешен производ</h2>
            <p class="pt-2">
                Ако пратката пристигне оштетена или во неа има погрешен производ, јавете ни се во рок од 3 дена од приемот,
                по можност со фотографија. Ќе ви пратиме нов производ или ќе ви ги вратиме парите, без трошок за вас.
                Ако кутијата е видливо оштетена уште при предавањето, побарајте од курирот да го запише тоа.
            </p>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Рок на траење</h2>
            <p class="pt-2">
                Сите производи ги испраќаме во оригинално пакување, со рок на траење отпечатен на амбалажата.
                Ако добиете производ со истечен рок, ќе го замениме без трошок за вас.
            </p>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Контакт</h2>
            <p class="pt-2">
                Телефон и Viber: <a class="text-primaryDark underline whitespace-nowrap" href="tel:+38973857133">073/857-133</a><br>
                Е-маил: <a class="text-primaryDark underline" href="mailto:aloeveragel.mk@gmail.com">aloeveragel.mk&#64;gmail.com</a>
            </p>
        </article>
        <app-footer></app-footer>
    `
})
export class ReturnsPolicyComponent {
}
